<template>
  <div>
    <van-overlay :show="loadingMask">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#ee0a24" />
        </div>
      </div>
    </van-overlay>

    <van-nav-bar title="行情">
      <template #right>
        <van-icon
          name="search"
          color="#ffffff"
          size="24px"
          @click="
            $router.push({
              name: 'TradingSearchStock',
              params: { route: 'kline' },
            })
          "
        />
      </template>
    </van-nav-bar>

    <img :src="banner" style="width: 100%" />
    <van-tabs
      id="activetab"
      v-model="active"
      @click="tabChange"
      style="margin-top: -5px"
    >
      <van-tab title="行情">
        <van-row class="rowDesign">
          <van-col
            v-for="(item, index) in dataArray"
            :key="index"
            span="8"
            class="columnDesign"
            @click="
              $router.push({ name: 'Kline', params: { code: item.code } })
            "
          >
            <div v-bind:class="[item.num >= 0 ? 'redText' : 'greenText']">
              <van-row class="topValue" style="font-size: 16px"
                ><span>{{ item.price }}</span>
              </van-row>
              <van-row style="font-size: 14px" class="topValue"
                ><van-col span="12"
                  ><span>{{ item.num }}</span></van-col
                >
                <van-col span="12"
                  ><span>{{ item.inrease }}%</span></van-col
                >
              </van-row>
            </div>
            <van-row style="font-size: 12px" class="topValue"
              ><span>{{ item.name }}</span>
            </van-row>
          </van-col>
        </van-row>

        <van-cell-group style="margin-top: 5px">
          <van-cell
            title="涨幅榜"
            is-link
            to="quotes/quotes_details"
            @click="goDetails(1)"
          />
          <van-cell
            title="跌幅榜"
            is-link
            to="quotes/quotes_details"
            @click="goDetails(2)"
          />
          <van-cell
            title="成交额"
            is-link
            to="quotes/quotes_details"
            @click="goDetails(3)"
          />
          <van-cell
            title="涨速榜"
            is-link
            to="quotes/quotes_details"
            @click="goDetails(4)"
          />
          <van-cell
            title="跌速榜"
            is-link
            to="quotes/quotes_details"
            @click="goDetails(5)"
          />
          <van-cell
            title="换手率"
            is-link
            to="quotes/quotes_details"
            @click="goDetails(6)"
          />
        </van-cell-group>
      </van-tab>
      <van-tab title="自选">
        <van-row class="tableheading"
          ><van-col span="6"><span>名称代码</span></van-col>
          <van-col span="6"><span>最新价</span></van-col>
          <van-col span="6"><span>涨跌</span></van-col>
          <van-col span="6"><span>成交量</span></van-col>
        </van-row>
        <van-list
          v-model="loadingQuotes"
          :finished="finishedQuotes"
          finished-text="没有更多了"
        >
          <div
            v-for="(item, index) in quotesList"
            :key="index"
            @click="onItem(item)"
          >
            <van-row class="tablecontent"
              ><van-col span="6"
                ><span>{{ item.name }} <br />{{ item.code }}</span></van-col
              >
              <van-col span="6" style="padding-top: 10px"
                ><span style="color: #0adc0aad">{{ item.price }}</span></van-col
              >
              <van-col span="6" style="padding-top: 10px"
                ><span style="color: #0adc0aad"
                  >{{ item.increase }}%</span
                ></van-col
              >
              <van-col span="6" style="padding-top: 10px"
                ><span>{{ item.num }}</span></van-col
              >
            </van-row>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Quotes",
  data() {
    return {
      active: 0,
      quotesList: [], //自选列表
      banner: "",
      title: [
        "关于我们",
        "新手指引",
        "策略指南",
        "交易规则",
        "注册协议",
        "公司资质",
        "联系我们",
        "帮助中心",
      ],
      topArray: ["sh000001", "sz399001", "sz399006"],
      dataArray: [],
      timmerRef: null,
      timmerRefConcern: null,
      refreshInterval: 2000,
      loadingMask: false,
      loadingQuotes: false,
      finishedQuotes: false,
    };
  },
  computed: {},
  methods: {
    onItem(item) {
      this.$router.push({ name: "Kline", params: { code: item.short } });
    },
    clearTimers() {
      clearInterval(this.timmerRef);
      clearInterval(this.timmerRefConcern);
    },
    tabChange() {
      this.clearTimers();
      switch (this.active) {
        case 0:
          this.getData();
          this.timmerRef = setInterval(() => {
            this.getData();
          }, this.refreshInterval);
          break;
        case 1:
          this.getSelfList();
          break;
        default:
          break;
      }
    },
    //获取自选列表
    getSelfList() {
      let that = this;
      that.loadingMask = false;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "concern",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var dataArr = res.data.data;
            if (dataArr.length != 0) {
              that.loadingQuotes = false;
              var shortArr = [];
              $.each(dataArr, function (index, item) {
                shortArr.push(item.short);
              });
              that.getNewPrice(shortArr, dataArr);
              that.timmerRefConcern = setInterval(function () {
                that.getNewPrice(shortArr, dataArr);
              }, that.refreshInterval);
            } else {
              clearInterval(window.timer3);
              that.quotesList = [];
              that.loadingQuotes = false;
              that.finishedQuotes = true;
            }
          } else if (res.data.code === 0) {
            that.$toast.fail(res.data.msg);
          } else if (res.data.code === -1) {
            that.$logout(res.data.msg);
          }
        })
        .catch(() => {
          that.loadingQuotes = false;
          that.finishedQuotes = true;
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    //请求当前价 计算 盈亏  盈亏比例
    getNewPrice(shortArr, dataArr) {
      let that = this;
      $.ajax({
        url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          that.loadingMask = false;
          var i, elements;
          for (i = 0; i < shortArr.length; i++) {
            var elements = eval("v_" + shortArr[i]).split("~");
            dataArr[i]["price"] = elements[3]; //当前价
            dataArr[i]["increase"] = elements[32];
            dataArr[i]["num"] = elements[36];
          }
          that.quotesList = dataArr;
          that.loadingQuotes = false;
          that.finishedQuotes = true;
        },
      });
    },
    bannerConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "hangqing_banner",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.banner = res.data.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    getData() {
      let that = this;
      $.ajax({
        url:
          "https://sqt.gtimg.cn/utf8/?q=" +
          that.topArray.toString() +
          "&_=" +
          new Date().getTime(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          var array = [];
          for (i = 0; i < that.topArray.length; i++) {
            elements = eval("v_" + that.topArray[i]).split("~");
            var elementNames = {};
            //dataArr[i]["price"]
            elementNames.price = elements[3];
            elementNames.inrease = elements[32];
            elementNames.num = elements[31];
            elementNames.name = elements[1];
            elementNames.id = elements[0];
            elementNames.code = that.topArray[i];
            array.push(elementNames);
          }
          that.dataArray = array;
        },
      });
    },
    goDetails(quotesId) {
      window.sessionStorage.setItem("quotesId", quotesId);
    },
  },
  mounted: function () {
    this.bannerConfig();
    this.tabChange();
  },
  destroyed: function () {
    this.clearTimers();
  },
};
</script>

<style scoped>
.rowDesign {
  text-align: center;
  line-height: 10px;
  padding-top: 5px;
}

.columnDesign {
  height: 82px;
  line-height: 82px;
  background: #ffffff;
  /* border-right: 5px solid #ebedf0; */
}

.topValue {
  text-align: center;
  line-height: 10px;
  padding-top: 14px;
}

.tableheading {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  padding-bottom: 14px;
  border-bottom: 1px solid #dcdee0;
  text-align: center;
  padding-top: 14px;
  color: #ff3334;
}

.tablecontent {
  font-size: 14px;
  height: 40px;
  line-height: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dcdee0;
  text-align: center;
  padding-top: 8px;
}
</style>

<style>
#activetab .van-tab {
  background: #dcdee0;
}

#activetab .van-tab--active {
  background: #ee0d25 !important;
  color: #ffffff;
}

#activetab .van-tabs__line {
  display: none;
}
.redText {
  color: red;
}
.greenText {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/Quotes.vue